import { createGate } from "effector-react";

// create product page gate which will be used to open and close product page
export const productPageGate = createGate("productPageGate");
